import getUrlParameter from './get-url-parameter'

export function clean(url, query) {
  const cleanUrl = removeDoubleSlash(url)
  const extraQueryFromUrl = (getUrlParameter('8S-api-debug-params') || '').split(',').join('&')
  const extraQuery = [query, extraQueryFromUrl].filter(query => query).join('&')
  return mergeQuery(cleanUrl, extraQuery)
}

function removeDoubleSlash(url) {
  return url.replace(/([^:]\/)\/+/g, '$1')
}

function mergeQuery(url, query) {
  if (!query) {
    return url
  }

  const aTag = document.createElement('a')
  aTag.href = url

  if (!aTag.search) {
    return `${url}?${query}`
  }

  return `${url}&${query}`
}
